module.exports = __webpack_public_path__ + "assets/packages/knative-plugin/src/imgs/channel.svg";